import { render, staticRenderFns } from "./CustomerOrdersInquiries.vue?vue&type=template&id=d2b39696&"
import script from "./CustomerOrdersInquiries.vue?vue&type=script&lang=js&"
export * from "./CustomerOrdersInquiries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports